var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexaogneAuditReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 242.941,
    height: 242.941,
    viewBox: "0 0 242.941 242.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 242.941,
    height: 242.941,
    rx: 55.382,
    ry: 55.382,
    fill: "#77c500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.19,173.833c-.07-.08-.15-.15-.18-.18l-32.8-32.81c6.85-9.08,10.6-20.22,10.6-31.59,0-28.97-23.58-52.55-52.55-52.55s-52.55,23.58-52.55,52.55,23.57,52.56,52.55,52.56c11.36,0,22.5-3.76,31.58-10.61l32.78,32.78c1.36,1.41,3.18,2.21,5.14,2.25h.15c1.9,0,3.7-.72,5.07-2.04,1.41-1.36,2.21-3.18,2.25-5.14.04-1.95-.68-3.81-2.04-5.22ZM136.69,135.403c-.48.38-.91.81-1.29,1.29-7.07,6.75-16.35,10.46-26.14,10.46-20.9,0-37.9-17-37.9-37.9s17-37.89,37.9-37.89,37.89,17,37.89,37.89c0,9.79-3.71,19.07-10.46,26.15Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexaogneAuditReady);
export default __webpack_public_path__ + "static/media/hexaogne-audit-ready.5b460b9ddcfdd877f997df8c74adc5b4.svg";
export { ForwardRef as ReactComponent };